import { isDevSession } from '../api/auth'
import { TOKENS } from './ui/dashboard-primitives'

/**
 * Persistent marker shown while the session is a Developer Mode token.
 *
 * Deliberately always-on and non-dismissable: you should never be able to
 * mistake dev for prod — that confusion is how a local test gets reported as a
 * production verification.
 */
export function DevSessionBadge() {
  if (!isDevSession()) return null
  return (
    <div
      aria-label="Developer session"
      // Mobile: the bottom-2 anchor the plan specified sits under the fixed
      // bottom nav (Sidebar.tsx's `sm:hidden` bar — h-12 items in a py-2
      // nav, ~4rem tall) and both share z-50, so the badge painted on top
      // and covered the leftmost tab. Cleared by the bar's content height
      // plus its own safe-area padding plus a small gap; sm: reverts to the
      // plan's bottom-2 since the desktop rail (Sidebar.tsx's `hidden
      // sm:flex` aside) has ~8px of real clearance from its lowest icon.
      //
      // Raising it moved the badge off the opaque nav bar and into the
      // live scrollable-content region — `pb-24` only reserves space at the
      // end of a page, not mid-scroll, so page text was showing through the
      // translucent 16%-alpha background. Background is now the solid
      // `--chrome-surface` token the coach dock and the bottom bar use for
      // exactly this "floating chrome over content" situation, so overlapped
      // text is fully hidden instead of bleeding through (`--warm-dark` is
      // 88% and let 12% show). Text color and border stay terracotta.
      className="pointer-events-none fixed bottom-[calc(4.75rem_+_env(safe-area-inset-bottom,0px))] left-2 z-50 rounded-full px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.14em] sm:bottom-2"
      style={{
        color: TOKENS.terracotta,
        background: 'var(--chrome-surface)',
        // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
        border: '1px solid rgba(198, 110, 77, 0.28)',
      }}
    >
      Dev session
    </div>
  )
}
